import { useMemo } from 'react'
import { CountryDto } from 'api/Identity/Types/Country'

export const useCountriesToCountryCodes = (countries: CountryDto[]): string[] =>
  useMemo(() => {
    return [
      ...new Set(
        countries
          .filter((country) => country.countryCodeNumber)
          .flatMap((country) => country.countryCodeNumber)
      ),
    ].sort()
  }, [countries])
